import { render, staticRenderFns } from "./NewEditAlunoPage.vue?vue&type=template&id=48cd6950&scoped=true"
import script from "./NewEditAlunoPage.vue?vue&type=script&lang=js"
export * from "./NewEditAlunoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cd6950",
  null
  
)

export default component.exports